import React from 'react';
import ThankYouPage from './components/ThankYouPage';
import './App.css';

function App() {
  return (
    <div className="app-container">
      <ThankYouPage />
    </div>
  );
}

export default App;